<template>
  <div class="onboarding_page">
    <h2>Behöver ni flera administratörer?</h2>
    <p>Just nu finns det en grupp som heter "Huvudadministratörer". Det är den grupp som du äger med detta konto.</p>
    <p>Ifall du har andra administratörer som behöver samma rättighet så skapar du en administratör under "Administratör" och lägger denna i gruppen "Huvudadministratörer".</p>
    <p>Ifall du vill att det ska finnas färre rättigheter eller tillgång till sidor bör du istället skapa en ny grupp och begränsa rättigheterna.</p>
    <p>Efter att du har skapat den nya gruppen så kan du sätta gruppen till administratörns grupp.</p>
    <p>En administratör kan bara tillhöra en grupp.</p>
    <p></p>
    <p>
      <a href="/ml-users" target="_blank">Till Administratör >></a>
    </p>
    <div class="wizard_actions mt-4">
      <memlist-button variant="secondary" @click="prev_page">Tillbaka</memlist-button>
      <memlist-button variant="primary" class="ml-8" @click="next_page">Fortsätt</memlist-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onboarding_page6',
  props: ['onboarding_data'],
  emits: ['next_page','prev_page','update_data'],
  watch: {
    onboarding_data: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_onboarding_data = { ...this.onboarding_data };
      },
      immediate: true
    },
  },
  data() {
    return {
      local_onboarding_data: null,
    }
  },
  methods: {
    next_page() {
      this.local_onboarding_data.admins_shown = true;

      this.$emit('update_data', this.local_onboarding_data);
      this.$emit('next_page');
    },
    prev_page() {
      this.$emit('prev_page');
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
